import{getMetaCsrfToken}from"../helpers";import{Ajax}from"./index";/**
 * Internal laravel ajax wrapper, it just adds the csrf token automatically to the
 * headers fo the request
 *
 * @param {string} endpoint The endpoint relative path, slashes will be normalised.
 */export function AjaxLaravel(endpoint,options={}){let headers=options.headers||{},crsfToken=getMetaCsrfToken();return crsfToken&&(headers["X-CSRF-TOKEN"]=crsfToken),options.headers=headers,Ajax(endpoint,options)}/**
 * Internal laravel ajax `GET` request shortcut
 *
 * @param endpoint The endpoint relative path, slashes will be normalised.
 */export function get(endpoint,options={}){return options.method="GET",AjaxLaravel(endpoint,options)}/**
 * Internal laravel ajax `POST` request shortcut
 *
 * @param endpoint The endpoint relative path, slashes will be normalised.
 */export function post(endpoint,options={}){return options.method="POST",AjaxLaravel(endpoint,options)}/**
 * Internal laravel ajax `DELETE` request shortcut
 *
 * @param endpoint The endpoint relative path, slashes will be normalised.
 */export function del(endpoint,options={}){return options.method="DELETE",AjaxLaravel(endpoint,options)}export default AjaxLaravel;